export default __webpack_public_path__ + "static/media/close.bed1341e.svg";